import React from 'react';
import CategoryVisibilitySelector from '../../admin/forms/CategoryVisibilitySelector';

const BulkSetVisibleCategoriesInputs = ({ staticData = {}, data, onInput, dependencies = {} }) => {
    const categories = dependencies.categories || [];
    const selectedPartners = staticData.selectedPartners || [];
    const selectedCategories = data.categoryIds || [];

    const handleCategoryChange = (updatedCategories) => {
        onInput(updatedCategories, 'categoryIds');
    };

    return (
        <React.Fragment>
            <p className="u-margin-bottom-1">
                Select the categories that should be visible to the selected{' '}
                <span className="u-bold">
                    {selectedPartners.length} media partner{selectedPartners.length === 1 ? '' : 's'}
                </span>{' '}
                for this event.
            </p>
            <p className="u-margin-top-2 u-margin-bottom-2" style={{ fontSize: '0.9em', color: '#666' }}>
                Important: This will overwrite the current visible categories for all selected partners. Partners may
                lose access to categories they previously had.
            </p>
            <div className="ckp-admin-grid-column">
                <CategoryVisibilitySelector
                    categories={categories}
                    selectedCategories={selectedCategories}
                    onChange={handleCategoryChange}
                    label="Visible Categories"
                />
            </div>
        </React.Fragment>
    );
};

export default BulkSetVisibleCategoriesInputs;
